import UniqueId from "parent/src/js/base/Utils/UniqueId";

export default class Waypoint {

	static get InViewClass() {
		return "in-view";
	}

	static get LeftViewClass() {
		return "left-view";
	}

	/**
	 * @param {string|HTMLElement|NodeListOf<HTMLElement>} selector
	 */
	constructor(selector) {
		this.threshold = .1;

		if (typeof selector === "string") {
			/**
			 *
			 * @type {NodeListOf<HTMLElement>}
			 */
			this.waypointEls = document.querySelectorAll(selector);
		}
		else if (selector instanceof HTMLElement) {
			if (selector.id === "") {
				selector.id = `Waypoint__${UniqueId()}`;
			}
			this.waypointEls = document.querySelectorAll(`#${selector.id}`);
		}
		else {
			this.waypointEls = selector;
		}

		if (this.waypointEls.length > 0) {
			window.addEventListener("resize", this.onUpdate.bind(this));
			window.addEventListener("load", this.onUpdate.bind(this));
			document.addEventListener("scroll", this.onUpdate.bind(this), {
				passive: true
			});
		}
	}

	checkIfInView() {
		const wh = window.innerHeight;
		this.waypointEls.forEach((item, index) => {
			const isTriggerAlways = item.hasAttribute("data-trigger-always");
			if (isTriggerAlways || !item.classList.contains("triggered")) {
				this.checkIfWaypointInView(item, isTriggerAlways, wh);
			}
		});
	}

	/**
	 *
	 * @param {HTMLElement} item
	 * @param {boolean} isTriggerAlways
	 * @param {?number} wh
	 */
	checkIfWaypointInView(item, isTriggerAlways, wh = null) {
		if (Waypoint.isInView(item, wh, this.threshold)) {
			if (!item.classList.contains(Waypoint.InViewClass)) {
				item.classList.add(Waypoint.InViewClass);
				item.dispatchEvent(new Event(Waypoint.InViewClass));
				if (!isTriggerAlways) {
					item.classList.add("triggered");
				}
			}
			item.classList.remove(Waypoint.LeftViewClass);
		}
		else {
			item.classList.add(Waypoint.LeftViewClass);
			item.classList.remove(Waypoint.InViewClass);
		}
	}

	/**
	 * @param {HTMLElement} item
	 * @param {?number} windowHeight
	 * @param {number} threshold
	 * @returns {boolean}
	 */
	static isInView(item, windowHeight = null, threshold = .1) {
		let iThreshold = item.getAttribute("data-threshold");
		if (iThreshold !== null) {
			threshold = parseFloat(iThreshold);
		}

		if (windowHeight === null) {
			windowHeight = window.innerHeight;
		}

		const bounds = item.getBoundingClientRect();
		const itemHeight = bounds.height;

		const hitbox = {
			top: windowHeight > itemHeight ? windowHeight * threshold : windowHeight - itemHeight,
			bottom: windowHeight > itemHeight ? windowHeight - (windowHeight * threshold) : itemHeight
		};

		hitbox.height = Math.abs(hitbox.bottom - hitbox.top);

		return (bounds.top >= hitbox.top && bounds.top <= hitbox.bottom)
			|| (bounds.bottom <= hitbox.bottom && bounds.bottom >= hitbox.top)
			|| (hitbox.bottom <= bounds.bottom && hitbox.top >= bounds.top && hitbox.height <= itemHeight);
	}

	/**
	 * @param {Event} e
	 */
	onUpdate(e) {
		const type = e.type;
		if (type !== "load") {
			this.checkIfInView();
		}
		else {
			window.setTimeout(() => {
				this.checkIfInView();
			}, 300);
		}
	}
}
